import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
// import TableChartIcon from "@mui/icons-material/TableChart";
// import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { Document, Packer, Paragraph, Table, TableCell, TableRow } from "docx";
// import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useDispatch, useSelector } from "react-redux";
import { fetchSources } from "../../../../../store/slices/sourceSlice";
import { setSourceFromDateRedux, setSourceRedux, setSourceToDateRedux } from "../../../../../store/slices/filterSlice";
import { setFilteredReports } from "../../../../../store/slices/filteredDataSlice";
import { setFilteredNavData } from "../../../../../store/slices/LeadreportfilteredSlice";
// import RemoveIcon from '@mui/icons-material/Remove';
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import DateConversion from "../../../../../utils/DateConversion";
import CommaConvert from "../../../../../utils/CommaConvert";
import { ChartColumnDecreasing, ChevronDown, TableOfContents } from "lucide-react";
import DownloadReport from "../../../../../pages/lead/DownloadReport";
import { setDownloadReportTitle } from "../../../../../store/slices/pageSlice";
import { hasViewOrFullAccess, getExactFeatureAccessLevel } from "../../../../../utils/featureAccessUtils";
const LeadSource = ({ currentEmployee, hasNoFeatureConfig, userLevel }) => {
    const dispatch = useDispatch();
    const currency = useCurrencySymbol();
    const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
    const USAComma = CommaConvert();
    const [leadsourceDownload, setLeadSourceDownload] = useState([]);
    const navigate = useNavigate();

    const downloadAccessLevel = !hasNoFeatureConfig && currentEmployee
        ? (
            getExactFeatureAccessLevel(currentEmployee, "LEAD SOURCE DOWNLOAD")
            ?? getExactFeatureAccessLevel(currentEmployee, "LEAD SOURCE GRAPHS")
        )
        : null;
    const isDownloadViewOnly = downloadAccessLevel && String(downloadAccessLevel).trim().toUpperCase() === "VIEW ONLY";

    const sendDownlodTile = () => {
        if (isDownloadViewOnly) return;
        dispatch(setDownloadReportTitle("LeadSourceReport"));
    };

    const canShowGraphs = userLevel === "L0" || hasNoFeatureConfig || !currentEmployee || hasViewOrFullAccess(currentEmployee, "LEAD SOURCE GRAPHS");
    const canShowFilter = userLevel === "L0" || hasNoFeatureConfig || !currentEmployee || hasViewOrFullAccess(currentEmployee, "LEAD SOURCE FILTER");

    const [filteredLeadReportsLead, setFilteredLeadReportsLead] = useState([]);
    const { filteredReports } = useSelector((state) => state.filteredData);
    const [showgraph, setShowgraph] = useState(true);
    const handleToggleCard = () => setShowgraph((v) => !v);
    useEffect(() => {
        if (filteredReports) {
            setFilteredLeadReportsLead(filteredReports);
        }
    }, [filteredReports]);

    useEffect(() => {
        dispatch(setFilteredReports());
    }, [dispatch]);

    useEffect(() => {
        if (filteredReports) {
            setLeadSourceDownload(filteredReports);
        }
    }, [filteredReports]);

    const [leadTab, setLeadTab] = useState("graph");
    // Chart is rendered with strict HTML/CSS columns to match the reference UI.

    const StatusdropdownRef = useRef(null);
    const [showsourseDropdown, setshowsourceDropdown] = useState(false);
    const [potentialSource, setPotentialSource] = useState([]);
    const [SourcesL1, setSourcesL1] = useState([]);
    console.log("potentialSource", potentialSource)
    const { source } = useSelector((state) => state.source);

    useEffect(() => {
        dispatch(fetchSources())
    }, [dispatch])

    useEffect(() => {
        if (source.length > 0) {
            setSourcesL1(source);
        }
    }, [source]);

    const [sourceFilterDateFrom, setSourceFilterDateFrom] = useState();
    const [sourceFilterDateTo, setSourceFilterDateTo] = useState();
    const [selectedSource, setSelectedSource] = useState("All");
    console.log("selectedSource 2All", selectedSource)

    const handleSourceDateFrom = (date) => {
        if (!date) return;
        setSourceFilterDateFrom(date);
        dispatch(setSourceFromDateRedux(date))
    }
    const handleSourceDateTo = (date) => {
        if (!date) return;
        setSourceFilterDateTo(date);
        dispatch(setSourceToDateRedux(date))
    }
    const handleSource = (source) => {
        if (!source) return;
        setSelectedSource(source)
        dispatch(setSourceRedux(source))
        setshowsourceDropdown(false); // Close dropdown on selection
    }

    const sourceFilterDateFromRedux = useSelector((state) => state.filters.sourceFilterDateFrom);
    const sourceFilterDateToRedux = useSelector((state) => state.filters.sourceFilterToDate);
    const sourceFilterRedux = useSelector((state) => state.filters.sourceFilter);

    useEffect(() => {
        if (sourceFilterDateFromRedux !== undefined && sourceFilterDateFromRedux !== null) {
            setSourceFilterDateFrom(sourceFilterDateFromRedux)
        } else { setSourceFilterDateFrom("") }
    }, [sourceFilterDateFromRedux])

    useEffect(() => {
        if (sourceFilterDateToRedux !== undefined && sourceFilterDateToRedux !== null) {
            setSourceFilterDateTo(sourceFilterDateToRedux)
        } else { setSourceFilterDateTo("") }
    }, [sourceFilterDateToRedux])
    useEffect(() => {
        if (sourceFilterRedux !== undefined && sourceFilterRedux !== null) {
            setSelectedSource(sourceFilterRedux)
        } else { setSelectedSource("All") }
    }, [sourceFilterRedux])

    // Handle clicks outside the dropdown to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                StatusdropdownRef.current &&
                !StatusdropdownRef.current.contains(event.target)
            ) {
                setshowsourceDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDownload = (event) => {
        if (isDownloadViewOnly) return;
        const value = event.target.value;

        if (value === "pdf") {
            downloadPDF();
        } else if (value === "word") {
            downloadWord();
        } else if (value === "excel") {
            downloadExcel();
        }
        setIsDropdownVisible(false);
    };

    const [isDropdownVisible, setIsDropdownVisible] = useState(false);

    // const toggleDropdown = () => {
    //     setIsDropdownVisible(!isDropdownVisible); // Toggle dropdown visibility
    // };

    const downloadExcel = () => {
        const sortedLeads = [...leadsourceDownload].sort(
            (a, b) => new Date(a.LeadDate) - new Date(b.LeadDate)
        );

        const ws = XLSX.utils.json_to_sheet(
            sortedLeads.map((LeadReport, index) => ({
                "Sr.No": index + 1,
                "Lead Date": LeadReport.LeadDate
                    ? formatDateByCountry(LeadReport.LeadDate)
                    : " ",
                "Client Name": LeadReport.ClientName,
                "Project Name": LeadReport.ProjectName,
                "Lead Type": LeadReport.LeadType,
                "Quoted Value": USAComma(LeadReport.QuotedValue), // ✅ Ensure it's a number
                Source: LeadReport.Source,
                Status: LeadReport.Status,
                Group: LeadReport.AssignedGroup,
                "Follow-up Date":
                    LeadReport.Status === "Won" || LeadReport.Status === "Lost"
                        ? " "
                        : formatDateByCountry(LeadReport.FollowupDate),
            }))
        );

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Lead Reports");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const excelFile = new Blob([excelBuffer], {
            bookType: "xlsx",
            type: "application/octet-stream",
        });
        saveAs(excelFile, "LeadSourceReports.xlsx");
    };

    const downloadPDF = () => {
        const doc = new jsPDF();
        doc.autoTable({
            head: [
                [
                    "Sr.No",
                    "Lead Date",
                    "Client Name",
                    "Project Name",
                    "Lead Type",
                    "Quoted Value",
                    "Source",
                    "Status",
                    "Group",
                    "Follow-up Date",
                ],
            ],
            body: leadsourceDownload.map((LeadReport, index) => [
                index + 1,
                LeadReport.LeadDate ? formatDateByCountry(LeadReport.LeadDate) : " ",
                LeadReport.ClientName,
                LeadReport.ProjectName,
                LeadReport.LeadType,
                `${currency}${USAComma(LeadReport.QuotedValue)}`,
                LeadReport.Source,
                LeadReport.Status,
                LeadReport.AssignedGroup,
                LeadReport.Status === "Won" || LeadReport.Status === "Lost"
                    ? " "
                    : formatDateByCountry(LeadReport.FollowupDate),
            ]),
            styles: {
                fontSize: 7,
            },
            headStyles: {
                fontSize: 8,
            },
        });
        doc.save("LeadSourceReports.pdf");
    };

    const downloadWord = () => {
        const headerRow = new TableRow({
            children: [
                new TableCell({
                    children: [new Paragraph("Sr.No")],
                }),
                new TableCell({
                    children: [new Paragraph("Lead Date")],
                }),
                new TableCell({
                    children: [new Paragraph("Client Name")],
                }),
                new TableCell({
                    children: [new Paragraph("Project Name")],
                }),
                new TableCell({
                    children: [new Paragraph("Lead Type")],
                }),
                new TableCell({
                    children: [new Paragraph("Quoted Value")],
                }),
                new TableCell({
                    children: [new Paragraph("Source")],
                }),
                new TableCell({
                    children: [new Paragraph("Status")],
                }),
                new TableCell({
                    children: [new Paragraph("Group")],
                }),
                new TableCell({
                    children: [new Paragraph("Follow-up Date")],
                }),
            ],
        });

        const dataRows = leadsourceDownload.map((LeadReport, index) => {
            return new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph(`${index + 1}`)],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph(
                                LeadReport.LeadDate ? formatDateByCountry(LeadReport.LeadDate) : " "
                            ),
                        ],
                    }),
                    new TableCell({
                        children: [new Paragraph(LeadReport.ClientName)],
                    }),
                    new TableCell({
                        children: [new Paragraph(LeadReport.ProjectName)],
                    }),
                    new TableCell({
                        children: [new Paragraph(LeadReport.LeadType)],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph(
                                `${currency}${USAComma(LeadReport.QuotedValue)}`
                            ),
                        ],
                    }),
                    new TableCell({
                        children: [new Paragraph(LeadReport.Source)],
                    }),
                    new TableCell({
                        children: [new Paragraph(LeadReport.Status)],
                    }),
                    new TableCell({
                        children: [new Paragraph(LeadReport.AssignedGroup)],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph(
                                LeadReport.Status === "Won" || LeadReport.Status === "Lost"
                                    ? " "
                                    : formatDateByCountry(LeadReport.FollowupDate)
                            ),
                        ],
                    }),
                ],
            });
        });

        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children: [
                        new Table({
                            rows: [headerRow, ...dataRows],
                        }),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then((blob) => {
            saveAs(blob, "LeadSourceReports.docx");
        });
    };

    const popupRef = useRef(null);

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setIsDropdownVisible(false); // Close the popup if clicked outside
        }
    };
    useEffect(() => {
        if (isDropdownVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isDropdownVisible]);

    // let source = lead.Source; // Assuming each lead has a status property
    // source = source?.toLowerCase()

    const [totalSourceAmount, setTotalSourceAmount] = useState(0);
    const [totalPercentage, setTotalPercentage] = useState(0);
    const [, setTotalGraphCount] = useState(0);
    const [totalSourcCount, setTotalSourcCount] = useState(0);

    const aggregateLeadSourceData = useCallback(
        (filteredData) => {
            if (!Array.isArray(filteredData) || filteredData.length === 0) {
                setPotentialSource([]);
                setTotalSourceAmount(0);
                setTotalSourcCount(0);
                setTotalPercentage(0);
                setTotalGraphCount(0);
                return;
            }

            const totalSourceAmount = filteredData.reduce(
                (sum, lead) => sum + (lead.QuotedValue || 0),
                0
            );
            const totalSourceCount = filteredData.length;
            setTotalGraphCount(totalSourceCount);
            const totalCalculatedCount = filteredData.length;

            const groupedData = filteredData.reduce((acc, lead) => {
                const source = lead.Source; // Assuming each lead has a status property
                // const source = lead.Source?.toLowerCase().trim();  // <-- CHANGE HERE

                if (!acc[source]) {
                    acc[source] = [];
                }
                acc[source].push(lead);
                return acc;
            }, {});

            const sourceData = Object.keys(groupedData).map((source) => {
                const leadsForSource = groupedData[source];

                const totalQuotedAmount = leadsForSource.reduce(
                    (sum, lead) => sum + (lead.QuotedValue || 0),
                    0
                );
                const count = leadsForSource.length;
                const percentage = ((count / totalSourceCount) * 100).toFixed(2);

                return {
                    amount: totalQuotedAmount,
                    count,
                    percentage,
                    source,
                };
            });
            const totalPercentage = sourceData
                .reduce((sum, source) => sum + parseFloat(source.percentage), 0)
                .toFixed(2);

            setTotalPercentage(totalPercentage);
            setPotentialSource(sourceData);
            setTotalSourceAmount(totalSourceAmount);
            setTotalSourcCount(totalCalculatedCount);
        },
        [
            setPotentialSource,
            setTotalSourceAmount,
        ]
    );

    // useEffect(() => {
    //   setFilteredLeadReportsLead(filteredLeadReports);

    // }, [filteredLeadReports]);

    useEffect(() => {
        if (filteredLeadReportsLead) {
            aggregateLeadSourceData(filteredLeadReportsLead);
        }
    }, [aggregateLeadSourceData, filteredLeadReportsLead]);

    const handleLeadingSourceFilter = () => {
        // Filter data based on date range and status selection
        const filteredData = filteredLeadReportsLead.filter((item) => {
            const itemDate = new Date(item.LeadDate);
            const isWithinDateRange =
                (!sourceFilterDateFrom || itemDate >= sourceFilterDateFrom) &&
                (!sourceFilterDateTo || itemDate <= sourceFilterDateTo);

            const isMatchingSource =
                !selectedSource ||
                selectedSource === "All" ||
                item.Source === selectedSource;
            return isWithinDateRange && isMatchingSource;
        });
        // Aggregate into source buckets for both graph + table views
        aggregateLeadSourceData(filteredData);
        setLeadSourceDownload(filteredData);
    };

    const leadSourceNavigationl1 = useCallback(
        (clickedSource) => {
            console.log("filteredDataLeadSourcel1 clickedSource", clickedSource)
            const filteredDataLeadSourcel1 = leadsourceDownload.filter(
                (item) => item.Source?.toLowerCase() === clickedSource?.toLowerCase()
            );
            console.log("filteredDataLeadSourcel1", filteredDataLeadSourcel1)
            dispatch(setFilteredNavData(filteredDataLeadSourcel1));
            navigate(`/dashboard/lead-report`);
        },
        [leadsourceDownload, navigate, dispatch]
    );

    const leadSourceCardBars = useMemo(() => {
        // Strict 4-column bar layout for the reference UI.
        // Percentages must come only from actual lead data.
        const canonical = [
            { key: "Channel Partner", label: "Channel Partner" },
            { key: "Direct", label: "Direct" },
            { key: "Reference", label: "Reference" },
            { key: "Website", label: "Website" },
        ];

        const bySource = new Map(
            (Array.isArray(potentialSource) ? potentialSource : [])
                .filter((x) => x && typeof x === "object")
                .map((x) => [String(x.source || "").toLowerCase(), x])
        );

        return canonical.map((c) => {
            const match = bySource.get(c.key.toLowerCase());
            const pct = match?.percentage != null && match?.percentage !== ""
                ? Math.round(Number(match.percentage))
                : 0;
            return { ...c, pct: Number.isFinite(pct) ? pct : 0 };
        });
    }, [potentialSource]);

    /** Y-axis tick labels only — matches 25% grid steps */
    const Y_AXIS_TICKS_FIVE = [100, 75, 50, 25, 0];

    // useEffect(() => {
    //   const renderSourceChart = () => {
    //     if (potentialSource.length > 0 && leadTab === "graph") {
    //       const ctxSource = sourcePieChart.current;
    //       if (sourceChartRef.current) {
    //         sourceChartRef.current.destroy();
    //       }

    //       const customLabelPlugin = {
    //         id: "customLabelPlugin",
    //         afterDatasetsDraw(chart) {
    //           const { ctx, data } = chart;
    //           ctx.save();
    //           ctx.font = "bold 14px Arial";
    //           ctx.textAlign = "center";
    //           ctx.textBaseline = "middle";

    //           data.datasets.forEach((dataset, datasetIndex) => {
    //             dataset.data.forEach((value, index) => {
    //               if (value === "" || value === 0) return;
    //               const meta = chart.getDatasetMeta(datasetIndex);
    //               const bar = meta.data[index];

    //               if (bar) {
    //                 const { x, y, base } = bar.tooltipPosition();
    //                 const barHeight = base - y;
    //                 const padding = 6;
    //                 const adjustedY = y - padding;
    //                 const percentage = Number(value);
    //                 ctx.fillStyle = barHeight > 30 ? "white" : "black";
    //                 // ctx.fillText(percentage, x, adjustedY);
    //                 if (percentage !== 0) {
    //                   ctx.fillText(`${percentage}%`, x, adjustedY);
    //                 }
    //               }
    //             });
    //           });

    //           ctx.restore();
    //         },
    //       };

    //       // Prepare data for all sources
    //       const orderedData = SourcesL1.map((source) => {
    //         const item = potentialSource.find(
    //           (p) => p.source === source.newSource
    //         );
    //         return {
    //           source: source.newSource,
    //           count: item ? item.count : 0,
    //         };
    //       });

    //       // Fix: Ensure all bars have values by default
    //       const filteredData = orderedData.map((item) => {
    //         if (selectedSourcefinal === "All") {
    //           return ((item.count / totalGraphCount) * 100).toFixed(2); // Show all values
    //         } else {
    //           return item.source === selectedSourcefinal
    //             ? ((item.count / totalGraphCount) * 100).toFixed(2) // Show selected source
    //             : ""; // Keep others visible but empty
    //         }
    //       });

    //       sourceChartRef.current = new Chart(ctxSource, {
    //         type: "bar",
    //         data: {
    //           labels: orderedData.map((item) => item.source),

    //           datasets: [
    //             {
    //               label: "Percentage",
    //               borderRadius: 8,
    //               data: filteredData,
    //               backgroundColor: ["#15803d", "#89AC46", "orange", "#DC2626"],
    //             },
    //           ],
    //         },
    //         options: {
    //           responsive: true,
    //           maintainAspectRatio: false,
    //           plugins: {
    //             legend: { display: false },
    //             tooltip: { enabled: false },
    //           },
    //           onClick: (event, elements) => {
    //             if (elements.length > 0) {
    //               const clickedElementIndex = elements[0].index;
    //               const clickedSource = orderedData[clickedElementIndex].source;
    //               leadSourceNavigationl1(clickedSource);
    //             }
    //           },
    //           scales: {
    //             x: {
    //               border: {
    //                 color: "black", //
    //               },
    //               grid: {
    //                 display: false,
    //                 border: {
    //                   color: "black",
    //                 },
    //               },
    //               ticks: {
    //                 color: "black",
    //                 font: {
    //                   size: 14,
    //                   weight: "bold",
    //                 },
    //               },
    //             },
    //             y: {
    //               display: false,
    //               grid: { display: false },
    //               ticks: { display: false },
    //               suggestedMin: 0,
    //               suggestedMax:
    //                 Math.max(...filteredData.map((v) => parseFloat(v))) + 10, // Adjust for better scaling
    //             },
    //           },
    //         },
    //         plugins: [customLabelPlugin],
    //       });
    //     }
    //   };
    //   renderSourceChart();
    // }, [
    //   leadTab,
    //   potentialSource,
    //   selectedSourcefinal,
    //   SourcesL1,
    //   totalGraphCount,
    //   leadSourceNavigationl1,
    //   showgraph
    // ]);

    // (Chart.js rendering removed; replaced with strict 4-column UI)

    return (
        <div className="flex h-full min-h-0 w-full flex-col rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
            <div className="shrink-0 px-0">
                <div className="flex flex-wrap items-center justify-between gap-3 pt-0">
                    <div className="flex items-center gap-3 min-w-0">
                        <button
                            type="button"
                            onClick={handleToggleCard}
                            className="flex shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white p-1.5 transition hover:bg-gray-50"
                            aria-expanded={showgraph}
                            aria-label={showgraph ? "Collapse" : "Expand"}
                        >
                            <ChevronDown
                                className={`h-4 w-4 text-gray-600 ${showgraph ? "" : "rotate-180"}`}
                                strokeWidth={2}
                            />
                        </button>
                        {leadTab === "table" && (
                            <button
                                type="button"
                                title="Graph"
                                className="flex shrink-0 items-center justify-center rounded-full bg-blue-600 p-1 text-white transition hover:bg-blue-700"
                                onClick={() => setLeadTab("graph")}
                                disabled={!showgraph}
                            >
                                <ChartColumnDecreasing className="h-5 w-5" strokeWidth={2} aria-hidden />
                            </button>
                        )}
                        {leadTab === "graph" && (
                            <button
                                type="button"
                                title="Table"
                                className="flex shrink-0 items-center justify-center rounded-full bg-blue-600 p-1 text-white transition hover:bg-blue-700"
                                onClick={() => setLeadTab("table")}
                                disabled={!showgraph}
                            >
                                <TableOfContents className="h-5 w-5 rotate-180" strokeWidth={2} aria-hidden />
                            </button>
                        )}
                        <h1 className="dashboard-card-title min-w-0 truncate">
                            LEAD SOURCE
                        </h1>
                    </div>

                    <div className="flex shrink-0 items-center justify-end">
                        {(userLevel === "L0" || hasNoFeatureConfig || !currentEmployee || hasViewOrFullAccess(currentEmployee, "LEAD SOURCE DOWNLOAD")) && (
                        <div className="flex justify-center items-center show-potential-download">
                            <div className="show-potential-download lg:justify-end  ">
                                <div className="relative inline-block">
                                    <div ref={popupRef} className={`flex items-center text-4xl sm:text-md md:text-xl lg:text-xl xl:text-2xl 2xl:text-4xl ${potentialSource.length === 0 ? 'opacity-50 pointer-events-none' : ''} ${isDownloadViewOnly ? 'opacity-60 pointer-events-none cursor-not-allowed text-[#9ca3af]' : ''}`}>
                                        <span onClick={() => sendDownlodTile()}>
                                            <DownloadReport tableLeadReports={leadsourceDownload} />
                                        </span>
                                        {isDropdownVisible && (
                                            <div

                                                className="absolute top-full  -left-8 shadow-lg  font-semibold z-50 bg-white text-base"
                                            >
                                                <div
                                                    className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                                                    onClick={() =>
                                                        handleDownload({ target: { value: "pdf" } })
                                                    }
                                                >
                                                    PDF
                                                </div>
                                                <div
                                                    className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                                                    onClick={() =>
                                                        handleDownload({ target: { value: "excel" } })
                                                    }
                                                >
                                                    Excel
                                                </div>
                                                <div
                                                    className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                                                    onClick={() =>
                                                        handleDownload({ target: { value: "word" } })
                                                    }
                                                >
                                                    Word
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}
                    </div>
                </div>
            </div>

            {showgraph && canShowGraphs && (
                <div className="mt-3 flex flex-col gap-3">
                    {canShowFilter && (
                    <div className="flex w-full flex-wrap items-end justify-between gap-4">
                        <div className="w-full sm:w-[22%] flex flex-col gap-1">
                            <div className="text-xs font-semibold text-[#1F2937]">From</div>
                            <div className="h-10 rounded-md border border-gray-300 bg-white px-2 flex items-center">
                                <DatePicker
                                    selected={sourceFilterDateFrom}
                                    onChange={handleSourceDateFrom}
                                    dateFormat={getDateFormat()}
                                    className="w-full h-full text-xs outline-none date-picker-placeholder bg-transparent"
                                    placeholderText={getDatePlaceholder()}
                                    required
                                />
                            </div>
                        </div>

                        <div className="w-full sm:w-[22%] flex flex-col gap-1">
                            <div className="text-xs font-semibold text-[#1F2937]">To</div>
                            <div className="h-10 rounded-md border border-gray-300 bg-white px-2 flex items-center">
                                <DatePicker
                                    selected={sourceFilterDateTo}
                                    onChange={handleSourceDateTo}
                                    dateFormat={getDateFormat()}
                                    className="w-full h-full text-xs outline-none date-picker-placeholder bg-transparent"
                                    placeholderText={getDatePlaceholder()}
                                    required
                                    minDate={
                                        sourceFilterDateFrom
                                            ? new Date(sourceFilterDateFrom.getTime() + 86400000)
                                            : null
                                    }
                                />
                            </div>
                        </div>

                        <div className="w-full sm:w-[22%] flex flex-col gap-1 relative">
                            <div className="text-xs font-semibold text-[#1F2937]">Source</div>
                            <div ref={StatusdropdownRef} className="relative">
                                <button
                                    type="button"
                                    onClick={() => setshowsourceDropdown(!showsourseDropdown)}
                                    className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-xs font-semibold text-[#1F2937] flex items-center justify-between"
                                >
                                    <span className="truncate">{selectedSource}</span>
                                    <ChevronDown size={18} className="shrink-0 text-gray-700" />
                                </button>
                                {showsourseDropdown && (
                                    <div className="absolute left-0 top-full z-50 mt-1 w-full max-h-48 overflow-y-auto border border-gray-300 bg-white text-xs font-semibold shadow-lg">
                                        <div
                                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={() => handleSource("All")}
                                        >
                                            All
                                        </div>
                                        {SourcesL1.map((Sourc) => (
                                            <div
                                                key={Sourc.id}
                                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                                onClick={() => handleSource(Sourc.newSource)}
                                            >
                                                {Sourc.newSource}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="w-full sm:w-[22%] flex flex-col font-semibold">
                            <div className="invisible text-xs select-none" aria-hidden>.</div>
                            <button
                                type="button"
                                className="h-10 w-full rounded-md border-2 border-gray-700 bg-white text-xs font-semibold text-[#1F2937] tracking-widest"
                                onClick={handleLeadingSourceFilter}
                            >
                                SUBMIT
                            </button>
                        </div>
                    </div>
                    )}

                    <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col bg-white pb-0">
                        {leadTab === "table" ? (
                            potentialSource.length > 0 ? (
                                <div className="w-full rounded-lg border border-gray-200 bg-white p-2">
                                    <div className="max-h-[18rem] overflow-auto">
                                        <table className="w-full divide-y divide-gray-200 border border-gray-200 text-xs text-gray-800">
                                            <thead className="sticky top-0 z-10 bg-gray-50 text-xs font-semibold uppercase tracking-wide text-gray-600">
                                                <tr>
                                                    <th className="border-b border-gray-200 px-3 py-2 text-left">
                                                        Source
                                                    </th>
                                                    <th className="border-b border-gray-200 px-3 py-2 text-center">
                                                        Count
                                                    </th>
                                                    <th className="border-b border-gray-200 px-3 py-2 text-center">
                                                        %
                                                    </th>
                                                    <th className="border-b border-gray-200 px-3 py-2 text-center">
                                                        Amount({currency})
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                {potentialSource.map((item, index) => (
                                                    <tr key={index}>
                                                        <td
                                                            onClick={() => leadSourceNavigationl1(item.source)}
                                                            style={{ cursor: "pointer" }}
                                                            className="border-b border-gray-200/40 px-3 py-1 text-left"
                                                        >
                                                            {String(item.source || "").toUpperCase()}
                                                        </td>
                                                        <td className="border-b border-gray-200/40 px-3 py-1 text-center">
                                                            {item.count}
                                                        </td>
                                                        <td className="border-b border-gray-200/40 px-3 py-1 text-center">
                                                            {item.percentage}
                                                        </td>
                                                        <td className="border-b border-gray-200/40 px-3 py-1 text-center">
                                                            {USAComma(item.amount)}
                                                        </td>
                                                    </tr>
                                                ))}
                                                <tr className="border-t border-gray-200 bg-gray-50 text-xs font-semibold">
                                                    <td className="px-3 py-2 text-left">TOTAL :</td>
                                                    <td className="px-3 py-2 text-center">{totalSourcCount}</td>
                                                    <td className="px-3 py-2 text-center">
                                                        {totalPercentage === "99.99" ? 100 : totalPercentage}
                                                    </td>
                                                    <td className="px-3 py-2 text-center">
                                                        {USAComma(totalSourceAmount)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex justify-center align-middle items-center text-center  w-full">
                                    <p className="noDataAvailable ">
                                        No data available
                                    </p> </div>
                            )
                        ) : (
                            <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden rounded-lg border border-gray-100 px-2 pb-3 pt-2">
                                <div className="w-full flex-1 min-h-[18rem] flex flex-col justify-end">
                                    <div className="relative">
                                        {/* Gridlines + baseline overlay (doesn't affect layout) */}
                                        <div className="pointer-events-none absolute left-0 right-0 top-[32px] h-44 z-0">
                                            <div className="relative h-full w-full">
                                                <div className="absolute inset-x-0 top-0 border-t border-gray-200/40" />
                                                <div className="absolute inset-x-0 top-[25%] border-t border-gray-200/40" />
                                                <div className="absolute inset-x-0 top-[50%] border-t border-gray-200/40" />
                                                <div className="absolute inset-x-0 top-[75%] border-t border-gray-200/40" />
                                                <div className="absolute inset-x-0 bottom-0 border-t border-gray-400" />
                                            </div>
                                        </div>

                                        {/* Y-axis % labels (overlay only; no layout changes) */}
                                        <div className="pointer-events-none absolute left-0 top-[38px] h-44 z-[1] flex w-9 flex-col justify-between text-xs font-medium text-gray-400">
                                            {Y_AXIS_TICKS_FIVE.map((v) => (
                                                <span key={v} className="relative -top-1 leading-none tabular-nums">
                                                    {v}%
                                                </span>
                                            ))}
                                        </div>

                                        <div className="grid grid-cols-4 gap-3 items-end relative z-10">
                                            {leadSourceCardBars.map((item) => (
                                                <div key={item.key} className="min-w-0 flex flex-col items-center justify-end gap-1">
                                                    <div className="relative -top-7 text-[18px] font-semibold text-[#1F2937] tabular-nums text-center">
                                                        {item.pct}%
                                                    </div>

                                                    <div className="h-44 w-full flex items-end justify-center">
                                                        <div
                                                            className="w-1/2 rounded-t-[14px]"
                                                            style={{
                                                                height: `${Math.max(0, Math.min(100, item.pct))}%`,
                                                                background:
                                                                    item.key === "Channel Partner"
                                                                        ? "linear-gradient(to top, #14532D 0%, #22C55E 100%)"
                                                                        : item.key === "Direct"
                                                                            ? "linear-gradient(to top, #1E40AF 0%, #3B82F6 100%)"
                                                                            : item.key === "Reference"
                                                                                ? "linear-gradient(to top, #C2410C 0%, #F59E0B 100%)"
                                                                                : "linear-gradient(to top, #9D174D 0%, #FB7185 100%)",
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="text-[13px] font-semibold text-[#1F2937] text-center whitespace-nowrap">
                                                        {item.label}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Baseline below labels removed (already have chart baseline) */}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

        </div>
    )
}

export default LeadSource